/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableActionsBaseTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions-base.template';
import { CartPurchaseOrderService } from './cart-purchase-order.service';

@Component({
  selector: 'pg-cart-purchase-order',
  templateUrl: './cart-purchase-order.component.html',
  providers: [MessageService]
})
export class CartPurchaseOrderComponent extends TableActionsBaseTemplate {
  @Input() groupItems;
  @Input() itemsReception: boolean;
  @Input() itemsInvoice: boolean;
  @ViewChild('op', { static: false }) opCart;
  @Output() items = new EventEmitter<any>();
  itemsCart: any = [];
  openSideBar = false;
  openConfirmRemove = false;
  itemToRemoveCart = null;
  itemToSideBar: any;
  constructor(
    private messageService: MessageService,
    private cartPurchaseOrderService: CartPurchaseOrderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.table.data = [];
    if (this.itemsReception) {
      this.table.settings = {
        title: 'Productos del Carrito',
        columns: [
          { header: 'Nombre', field: 'name' },
          { header: 'Unidad de medida', field: 'unitMeasure' },
          { header: 'Cantidad', field: 'quantity' },
          { header: 'Cant. Recibida', field: 'quantity_received' },
          { header: 'Cant. en Carrito', field: 'quantity_cart' },
          { header: 'Lote', field: 'lot' },
          { header: 'Fecha Venc.', field: 'expDate' }
        ]
      };
    } else {
      if (this.itemsInvoice) {
        this.table.settings = {
          title: 'Productos del Carrito',
          columns: [
            { header: 'Nombre', field: 'name' },
            { header: 'Unidad de medida', field: 'unitMeasure' },
            { header: 'Cantidad', field: 'quantity' },
            { header: 'Cant. Facturada', field: 'quantity_invoiced' },
            { header: 'Cant. en Carrito', field: 'quantity_cart' }
          ]
        };
      } else {
        this.table.settings = {
          title: 'Productos del Carrito',
          columns: [
            { header: 'Nombre', field: 'description' },
            { header: 'Unidad de medida', field: 'unitMeasureDescription' },
            { header: 'Cantidad', field: 'quantity' },
            { header: 'Precio Unitario', field: 'unitPrice', pipe: 'Currency' },
            { header: 'Descuento', field: 'discount', pipe: 'Currency' }
          ]
        };
      }
    }
    this.table.actions = [
      {
        name: 'update-product-cart-sale',
        icon: 'pi pi-pencil',
        class: 'p-button-rounded p-button-success mr-2',
        pTooltip: 'Actualizar Producto'
      },
      {
        name: 'remove-product-cart-sale',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-warning mr-2',
        pTooltip: 'Remover Producto'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.cartPurchaseOrderService
      .getData$()
      .subscribe((data: any[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  onReciveAction(event: any): void {
    if (event.action === 'update-product-cart-sale') {
      this.itemToSideBar = event.data;
      this.openSideBar = true;
    } else if (event.action === 'remove-product-cart-sale') {
      this.openConfirmRemove = true;
      this.itemToRemoveCart = event.data;
    }
  }

  removeItemCart() {
    this.cartPurchaseOrderService.removeItem(this.itemToRemoveCart);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Removido',
      detail: 'Producto Removido Satisfactoriamente del Carrito'
    });
    this.openConfirmRemove = false;
    this.itemToRemoveCart = null;
  }

  onOpenItemsCart() {
    this.open = true;
  }

  onCloseSideBar() {
    this.openSideBar = false;
  }
}
